<template>
  <div class="d-flex flex-column">
    <div class="grid-header">
      <h1>{{$t("clientes.titulo")}}</h1>
      <div class="toolbar">
      </div>
    </div>

    <DxDataGrid v-bind="getDefaultGridProperties()" :data-source="gridSource" ref="grid" class="dx-card wide-card grid-clientes">
      <DxColumn data-field="NombreCompleto" :caption="$t('clientes.grid.nombre')"></DxColumn>
      <DxColumn data-field="Documento" :caption="$t('clientes.grid.documento')"></DxColumn>
      <DxColumn data-field="OperacionesAsociadas" :caption="$t('clientes.grid.operaciones_asociadas')" data-type="number"></DxColumn>
      <DxColumnFixing :enabled="true" />
      <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
      <template #masterDetailTemplate="{ data: cliente }">
        <clientes-grid-detail :template-data="cliente" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { useApi } from "@api/integration";
import {
  DxColumn,
  DxDataGrid,
  DxMasterDetail,
  DxColumnFixing,
} from "devextreme-vue/data-grid";
import {
  getDefaultGridProperties,
} from "@helpers/grid-helper";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import ClientesGridDetail from "@/components/clientes/ClientesGridDetail.vue";

const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();

onMounted(async () => {
  gridSource.value = api.apiStore({
    key: "IdCliente",
    load: await api.toStandardApiFunction("getClientesAgenteForGrid", {showLoading: false})
  });
});

</script>

<style lang="scss" scoped>


</style>
